import gql from "graphql-tag";

const getAllWorkOvertimeRate = gql`
  query {
    getAllWorkOvertimeRate {
      id
      name
    }
  }
`;

export default { getAllWorkOvertimeRate };
